import { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import * as Sentry from '@sentry/react';
import { doc, onSnapshot } from 'firebase/firestore';
import { resolveAppSettings } from '@flintmint/core-shared/utils';

import { useServices } from '@/providers/services-provider';
import { appSettingsAtom } from '@/state';

export const useAppSettingsListener = () => {
  const { firestore } = useServices();
  const setAppSettings = useSetAtom(appSettingsAtom);

  useEffect(() => {
    if (!firestore) return;

    return onSnapshot(
      doc(firestore, 'settings', 'app'),
      (snapshot) => {
        if (snapshot.metadata.fromCache && !snapshot.exists()) return;

        setAppSettings(resolveAppSettings(snapshot.data(), Sentry.captureMessage));
      },
      (error) => Sentry.captureException(error)
    );
  }, [firestore, setAppSettings]);
};
